import { useState, useEffect, useCallback } from 'react';
import sessionManager from '../services/SessionManager';

/**
 * Hook fuer SessionManager als Single Source of Truth.
 * Ersetzt den 60s-Poll in MainScreen - nutzt stattdessen
 * SessionManager Events (WebSocket + 30s Heartbeat + localStorage).
 */
export function useSessionManager() {
  const [activeSession, setActiveSession] = useState(
    sessionManager.getCurrentSession()
  );

  useEffect(() => {
    const unsubscribe = sessionManager.addEventListener((eventType) => {
      // Bei jedem Event: aktuellen State aus SessionManager lesen
      const current = sessionManager.getCurrentSession();
      setActiveSession(current);
    });
    return unsubscribe;
  }, []);

  /**
   * Einmaliger Server-Check beim App-Start.
   * Vergleicht localStorage mit Server-Realitaet.
   */
  const checkServerSession = useCallback(async () => {
    try {
      const { apiService } = await import('../services/api');
      const response = await apiService.getMyActiveSession();

      if (response?.data?.id) {
        // Server hat eine aktive Session
        const local = sessionManager.getCurrentSession();
        if (!local || local.id !== response.data.id) {
          // Server gewinnt bei Diskrepanz. adoptServerSession legt die Session auch
          // im localStorage ab - ohne das stoppte der Heartbeat beim ersten Tick.
          sessionManager.adoptServerSession(response.data);
        }
        setActiveSession(response.data);
      } else {
        // Server hat keine aktive Session
        const local = sessionManager.getCurrentSession();
        if (local) {
          sessionManager.cleanupSession();
        }
        setActiveSession(null);
      }
    } catch (error) {
      // Bei Netzwerkfehler: localStorage-State beibehalten
      console.warn('Server-Session-Check fehlgeschlagen:', error.message);
    }
  }, []);

  return { activeSession, checkServerSession };
}

export default useSessionManager;
